import React from "react"
import {toActivityFactory, stateFilter, defaultState} from "./cd"
import * as shared from "activities/components/shared"

export default shared.ActivityFactory(toActivityFactory("share-certificate", "Share Certificate"), {
  stateFilter,
  defaultProps: {
    id: "share-certificate-calculator",
    className: "share-certificate-calculator",
    title: "Share Certificate Calculator",
    subtitle: "Adjust the inputs to see how much your savings in a share certificate grow over time."
  },
  defaultState
})
